import React from 'react'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import Hide from '@/component/Primitive/Hide'
import Type from '@/component/Primitive/Type'
import styles from './Image.module.scss'
import { object, oneOf, shape, string } from 'prop-types'
import cx from 'classnames'

const defaultImageLabel = {
  label: 'Switching stage',
  stage: null
}

export const Image = ({
  device,
  image,
  classNames,
  imageLabel = defaultImageLabel,
  options = { ignoreWrapper: false }
}) => {
  const hideProps = device === 'mobile' ? { at: 'tablet' } : { below: 'tablet' }
  const className =
    device === 'mobile' ? styles.mobileImage : styles.desktopImage
  return (
    <Hide
      {...hideProps}
      className={cx(
        styles.ImageWrapper,
        options.ignoreWrapper && styles.ignoreWrapper,
        classNames?.container
      )}
    >
      {image ? (
        <ResponsiveImage
          className={cx(styles.Image, className, classNames?.image)}
          {...image}
        />
      ) : (
        <div className={styles.Loading}>
          <Type
            className={styles.Label}
            as="h3"
            size={['body3', 'body2']}
            weight="regular"
          >
            Switching to {'  '}
            <span className={styles.Stage}>{imageLabel?.stage}</span>
          </Type>
        </div>
      )}
    </Hide>
  )
}

Image.propTypes = {
  device: oneOf(['mobile', 'tablet', 'desktop']),
  image: object,
  classNames: shape({
    image: string,
    container: string
  }),
  imageLabel: shape({
    label: string,
    stage: string
  }),
  options: shape({
    ignoreWrapper: string
  })
}
